/**
 * Version and date shown on published legal documents.
 *
 * LEGAL_DOCUMENT_VERSION must equal LEGAL_SIGNUP_CONSENT_VERSION in
 * `server/src/constants/userPrivacyConsent.constants.js` — the server records that value
 * when a user accepts, so a mismatch would show readers a different version than the one
 * stored against their consent. Enforced by
 * `server/src/constants/__tests__/legalVersionParity.test.js`.
 *
 * Bump both together whenever the Terms or Privacy Policy meaningfully change; existing
 * users are then re-prompted to accept.
 */

export const LEGAL_DOCUMENT_VERSION = '2026-09-legal-v2' as const

/** Human-readable date shown beside the version. */
export const LEGAL_DOCUMENT_LAST_UPDATED = '12 September 2026' as const
